import React from 'react';
import {useIntl} from 'react-intl';
import {FlexContainer, Heading, TextField, Link as LinkComponent, FlexRow, FlexColumn} from '@forecast-it/design-system';

import {Content, HorizontalLine, Page, PageContent, WideButton} from './Sage.styled';
import {Link as RouterLink} from 'react-router-dom';
import Logo, {LOGO_SIZE} from '../../forecast-app/shared/components/logo/Logo';

export type SageLoginProps = {
	errorMessage?: string;
	email?: string;
	onEmailChange: (value: string) => void;
	passwordError?: string;
	password?: string;
	onPasswordChange: (value: string) => void;
	onLogin: () => void;
};

export const SageLogin = ({
	errorMessage,
	email,
	onEmailChange,
	passwordError,
	password,
	onPasswordChange,
	onLogin,
}: SageLoginProps): JSX.Element => {
	const {formatMessage} = useIntl();
	return (
		<Page>
			<Content alignItems="center" justifyContent="center">
				<Logo size={LOGO_SIZE.MEDIUM} />
				<FlexContainer>
					<PageContent gap="xl">
						<FlexColumn gap="l">
							<Heading size="3">{formatMessage({id: 'sage.login.title'})}</Heading>
							<TextField
								label={formatMessage({id: 'common.email'})}
								autoComplete="email"
								errorText={errorMessage}
								value={email}
								onValueChange={onEmailChange}
							/>
							<TextField
								isPasswordField
								label={formatMessage({id: 'common.password'})}
								autoComplete="password"
								maxLength={64}
								value={password}
								errorText={passwordError}
								onValueChange={onPasswordChange}
							/>
						</FlexColumn>
						<RouterLink to="/forgot-password" component={LinkComponent}>
							{formatMessage({id: 'login.forgot-your-password'})}
						</RouterLink>
						<WideButton onPress={onLogin}>{formatMessage({id: 'login.log-in'})}</WideButton>
						<HorizontalLine />
						<FlexRow alignItems="center" justifyContent="center">
							<LinkComponent href={'https://app.forecast.it/'}>
								{formatMessage({id: 'sage.looking_for_forecast'})}
							</LinkComponent>
						</FlexRow>
					</PageContent>
				</FlexContainer>
			</Content>
		</Page>
	);
};
